export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5606.4a4bae61.jpg";